import React from 'react';
import { Link } from 'react-router-dom';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';

/**
 * Curriculum Dashboard
 * Provides centralized access to all academic data management:
 * Regions, Syllabuses, Streams, Classes, and Courses.
 */
function Curriculum() {
  const dashboardTiles = [
    {
      to: '/manage/est',
      icon: '🌍',
      title: 'Regions',
      description: 'Manage countries and educational systems',
      className: 'region-tile',
    },
    {
      to: '/manage/es',
      icon: '📋',
      title: 'Syllabuses',
      description: 'Manage boards and educational systems',
      className: 'syllabus-tile',
    },
    {
      to: '/manage/stream',
      icon: '🌱',
      title: 'Streams',
      description: 'Manage academic streams and tracks',
      className: 'stream-tile',
    },
    {
      to: '/manage/classes',
      icon: '🏫',
      title: 'Classes',
      description: 'Manage grades and educational levels',
      className: 'class-tile',
    },
    {
      to: '/manage/subjects',
      icon: '📘',
      title: 'Subjects',
      description: 'Manage academic subjects and tracks',
      className: 'subject-tile',
    },
  ];

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <div className="tab__content ___adjust___tab___padding">
          {/* Breadcrumbs */}
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[{ label: 'Dashboard', to: '/dashboard' }]}
              current="Manage Curriculum"
            />
          </div>

          <div className="tab__content-actBody px-5 py-5">
            <div className="row mb-5">
              <div className="col-12">
                <h2 className="prime-head boldtitle">Manage Curriculum</h2>
                <p className="text-muted">
                  Centralized hub for managing all academic hierarchies and course materials.
                </p>
              </div>
            </div>

            {/* Dashboard Grid */}
            <div className="podcast-content">
              <div className="tiles-container">
                {dashboardTiles.map((tile, index) => (
                  <Link key={index} to={tile.to} className={`tile ${tile.className}`}>
                    <article>
                      <div className="tile-icon">{tile.icon}</div>
                      <h3 className="tile-title">{tile.title}</h3>
                      <p className="tile-description">{tile.description}</p>
                    </article>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Curriculum;
